export const data: any = {
  NEXT_PUBLIC_BASE_URL: "https://sketchup.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://sketchup.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "sketchup",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "5qimfmsew7zl",
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_ONETRUST_ID: "01983dd7-95e2-7626-9668-6f9d198e061f",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "prod_skup_trmb",
  NEXT_PUBLIC_VWO_ACCOUNT_ID: "1212941",
}